module.exports = __webpack_public_path__ + "static/media/password-icon.d211241e.svg";